import React from 'react';
import settingsStyles from '../settingsStyles';

// Ayarlar sayfasindaki her bolumun ortak kabugu: ikon + baslik + aciklama + sag ust aksiyon.
// id, sol menudeki bolum baglantisinin hedefi olur.
export default function SectionCard({id, icon, title, description, meta, actions, children}) {
    const classes = settingsStyles();

    return (
        <section className={classes.card} id={id}>
            <header className={classes.cardHeader}>
                <span className={classes.cardHeaderIcon}>
                    <i className={icon} />
                </span>
                <div className={classes.cardHeaderText}>
                    <h2 className={classes.cardTitle}>{title}</h2>
                    {description && <p className={classes.cardDesc}>{description}</p>}
                </div>
                {(meta || actions) && (
                    <div className={classes.cardHeaderActions}>
                        {meta && <span className={classes.cardHeaderMeta}>{meta}</span>}
                        {actions}
                    </div>
                )}
            </header>
            {children}
        </section>
    );
}
